


export const jurFormVoList = JSON.stringify([
    {
        isForm: 1,
        isShowForm: 0,
        jciId: 11717,
        jciName: "出库申请主信息表单",
        jciType: 1,
        index: 0,
        jurId: "1698307975196",
        jurconfigform: [
            
            // {
            //     chineseField: "销售单位",
            //     defaultValue: "",
            //     entityField: "cmName",
            //     extractId: null,
            //     fieldType: "search",
            //     setField: "cmName,cmId",
            //     fieldWeight: 180,
            //     searchId:'3391151360249856',
            //     focusField: "",
            //     isChange: 1, isUpdate: 0
            // },
            // {
            //     chineseField: "业务员",
            //     defaultValue: "",
            //     entityField: "opmName",
            //     extractId: null,
            //     searchId:'4444770562019328',
            //     fieldType: "search",
            //     fieldWeight: 180,
            //     setField: "opmName,opmId",
            //     focusField: "",
            //     isChange: 1, isUpdate: 0
            // },
            // {
            //     chineseField: "对方业务员",
            //     defaultValue: "",
            //     entityField: "salesName",
            //     extractId: null,
            //     searchId:'8820873997127680',
            //     fieldType: "search",
            //     fieldWeight: 180,
            //     setField: "salesName,salesId",
            //     focusField: "",
            //     isChange: 1, isUpdate: 0
            // },
            // {
            //     chineseField: "货主名称",
            //     defaultValue: "",
            //     entityField: "coName",
            //     extractId: null,
            //     fieldType: "search",
            //     searchId:'4414428383875072',
            //     fieldWeight: 180,
            //     setField: "coName,coId",
            //     focusField: "",
            //     isChange: 1, isUpdate: 0
            // },
            {
                chineseField: "手术时间",
                defaultValue: "",
                entityField: "operationTime",
                extractId: null,
                fieldType: "date",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "科室",
                defaultValue: "",
                entityField: "roomName",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "病人姓名",
                defaultValue: "",
                entityField: "patientName",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "年龄",
                defaultValue: "",
                entityField: "ageNum",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "住院号",
                defaultValue: "",
                entityField: "courtNum",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "床位号",
                defaultValue: "",
                entityField: "bunkCode",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "病人电话",
                defaultValue: "",
                entityField: "patientPhone",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "身份证号",
                defaultValue: "",
                entityField: "idcardNum",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "手术类型",
                defaultValue: "",
                entityField: "surgicalType",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "术者",
                defaultValue: "",
                entityField: "surgeonName",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "备注",
                defaultValue: "",
                entityField: "wsRemark",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
          
        ]
    }

]
)
export const tabledata = [

]